module.exports = __webpack_public_path__ + "static/media/PriceProfile.45938527.svg";